module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-16.14afac4a.png";